export interface ActivityType {
  activityTypeId: number;
  activityType: string;
  isInteraction: boolean;
}

export enum ActivityTypeEnum {
  Task = 1,
  Call = 3,
  Communication = 4,
  Note = 6,
  Meeting = 7,
}
